var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBookmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 16,
  viewBox: "0 0 15 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.2695 2.81257C13.2695 2.33371 13.1051 1.91714 12.7769 1.56229C12.4487 1.20857 12.0586 1.03143 11.607 1.03143H2.67868C2.22716 1.03143 1.83645 1.20857 1.50823 1.56229C1.18001 1.91714 1.01562 2.33371 1.01562 2.81257V14.3126L7.2045 10.2811L13.2695 14.2811V2.81257ZM13.5156 0.812571C14.029 1.35429 14.2857 2.01086 14.2857 2.78114V16L7.2045 11.3749L0 16V2.78114C0 2.01086 0.256721 1.35429 0.769599 0.812571C1.28248 0.271429 1.89838 0 2.61675 0H11.6684C12.3873 0 13.0027 0.271429 13.5156 0.812571Z",
  fill: "#4585FF"
})));
export default SvgIconBookmark;